import * as React from 'react';
import PropTypes from 'prop-types';
import './footer.scss';
import { footerLinks } from './footer.const';
import dayjs from 'dayjs';

const Footer = () => {
  const [selectedLink, setSelectedLink] = React.useState('');
  const [selectedLinkInner, setSelectedLinkInner] = React.useState('');

  const openDropDown = (element: any) => {
    setSelectedLink(element === selectedLink ? '' : element);
  };

  const openDropDownInner = (element: any) => {
    setSelectedLinkInner(element === selectedLinkInner ? '' : element);
  };

  const generateLink = (info: any, counter: any, view: any) => {
    return (
      <>
        {info.isDropDown ? (
          <>
            <div
              key={`footer-${info.key}-${view}-${info.label.replace(/ /g, '-')}`}
              className="link section-dropdown"
              onClick={() => openDropDownInner(info.label)}
            >
              <div className="link-text">{info.label}</div>
              <div className={`link-icon product-dropdown-icon ${selectedLinkInner === info.label ? 'open' : 'close'}`}></div>
            </div>
            <div className={`link-listing child-dropdown ${selectedLinkInner === info.label ? 'display-child' : ''}`}>
              {info.children && (
                <>
                  {info.children.map((links: any, index: any) => (
                    <>{generateLink(links, index, view)}</>
                  ))}
                </>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="link" key={`footerLinks-${info.key}-${view}-${info.label.replace(/ /g, '-')}`}>
              <a href={info.link} target={info.isPDF ? '_blank' : '_self'} rel="noreferrer">
                {info.label}
              </a>
            </div>
          </>
        )}
      </>
    );
  };

  const generateLinkBlock = (section: any, type: boolean, view: any) => {
    if (section.icon) {
      type = false;
    }
    return (
      <>
        <div className={`link-border-bottom ${section.icon ? 'icon-block' : ''}`}>
          <div
            className={`link-heading md:my-3 ${section.isDropDown || type ? 'section-dropdown' : ''}`}
            onClick={() => openDropDown(section.label)}
          >
            <div>
              <div className="heading">{section.label}</div>
              {section.subheading && (
                <>
                  <div className="subheading">{section.subheading}</div>
                </>
              )}
            </div>
            {(section.isDropDown || type) && (
              <div className={`link-icon product-dropdown-icon ${selectedLink === section.label ? 'open' : 'close'}`}></div>
            )}
          </div>
          <div
            className={`link-listing ${section.isDropDown || type ? 'child-dropdown' : ''} ${
              selectedLink === section.label ? 'display-child' : ''
            }`}
          >
            {section.children && (
              <>
                {section.children.map((links: any, index: any) => (
                  <>{generateLink(links, index, view)}</>
                ))}
              </>
            )}
          </div>
        </div>
      </>
    );
  };

  const sectionBlockRender = (block: any) => {
    return (
      <>
        {block.map((section: any) => (
          <div key={`footerLinksSection-${section.key}`} className={`${section.display === false ? 'hidden' : ''}`}>
            <div className={`desktop`}>{generateLinkBlock(section, false, 'desktop')}</div>
            <div className="mobile">{generateLinkBlock(section, true, 'mobile')}</div>
            {section.icon && (
              <>
                <div className="follow-us-block">
                  <a href="https://twitter.com/InCredFin">
                    <div className="icons twitter"></div>
                  </a>
                  <a href="https://www.facebook.com/InCredIndia/">
                    <div className="icons facebook"></div>
                  </a>
                  <a href="https://www.linkedin.com/company/incredfinancialservices/mycompany/">
                    <div className="icons linkedin"></div>
                  </a>
                  <a href="https://www.instagram.com/incredfin/">
                    <div className="icons instagram"></div>
                  </a>
                  <a href="https://www.youtube.com/channel/UCWDW_L_2lSaDAL4O5ghj7yg">
                    <div className="icons youtube"></div>
                  </a>
                </div>
              </>
            )}
          </div>
        ))}
      </>
    );
  };

  return (
    <>
      <div className="footer-block">
        <div className="container">
          <div className="grid">
            <div className="col-12">
              {/* <div className="contactus-block">
                <div className="message">
                  <div className="heading">Contact Us</div>
                  <div className="subheading">
                    Call us on toll free number <a href="tel:18001022192">1800 102 2192</a> or email us at{' '}
                    <a href="mailto:care@incred.com">care@incred.com</a>
                  </div>
                </div>
                <div className="image"></div>
              </div> */}
            </div>
          </div>
          <div className="link-block">
            <div className="flex link-container">
              {footerLinks.map((block, i) => (
                <div className="px-2 link-block-container" key={`footerLinksBlock-${i}`}>
                  {sectionBlockRender(block)}
                </div>
              ))}
            </div>
            <div className="copyright-block p-2 pb-3 mt-2">
              <div className="copyright">&#169; Copyright {dayjs().year()} InCred</div>
              <div className="company-name">
                InCred Financial Services Limited (Formerly &quot;KKR India Financial Services Limited&quot;) is a NBFC registered with the RBI{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Footer.propTypes = {
  siteTitle: PropTypes.string,
};

Footer.defaultProps = {
  siteTitle: ``,
};

export default Footer;
